import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cdatatype(){

    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(2.5)
      } else {
        setWindowpadding(14)
      }
    }
  
    
    const right = {
      padding: '0 0 0 '+padding+'rem',
    };
return(
    <div>
       

        <Sides/>
       <Helmet>
 
 <title>C++ Data Types tutorial For Beginners</title>
 <meta name="description" content="C++ Data Types tutorial for beginners.There are three types of C++ datatypes,CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,c++ data type,c++ data types,data type of cpp,c++ data types size,c++ data type size,data type cpp programming,data type of cpp language,cpp data type float,cpp abstract data type,data type of cpp language,cpp data type conversion,cpp data type size" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-array" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">C++ Data Types</h1>
    <div className="first">
        <a href="/csharp-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<h2 className="m-4 para">There are three types of C++ datatypes:
</h2>
<h3 className="m-4 para">1,Value Data Type<br/>
2,Pointer Data Type<br/>
3,Reference Data Type<br/>
</h3>
<p className="m-4 para"><span className="bold">1,Value Data Type:</span>int,float,double,short,ushort,bool,long,char etc.<br/>
<span className="bold">2, pointer Data Type:</span>pointer<br/>
<span className="bold">3, Reference Data type:</span> object,class,interface,etc.
</p>

<h2 className="m-4">There are 8 types of primitive data types in C++</h2>
<h3 className="m-4">1.Int<br/>
2,float<br/>
3, double<br/>
4, Boolean<br/>
5, byte<br/>
6, Short<br/>
7, Char<br/>
8, Long<br/>
</h3>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">C++ Datatypes Example:</Card.Header>
<Card.Body>
 <Card.Text>
<p>  int a=10;<br/>
float a=20.8f<br/>
double a=20.8456456<br/>
boolean a=true/false<br/>
byte a =10<br/>
short a=10000<br/>
character a = 'a';<br/>
long a=10525252272544L<br/>
</p>
 </Card.Text>
</Card.Body>
</Card>

<h3 className="m-4 bold ">1,Integers C++ data type -<br/></h3>
<p className="para">In Integers C data type this group includes int, long, short and byte and this is a whole value number
integers include positive, negative and all type of signs but without decimal<br/>
<span className="bold p-4">A,In Integers C++ data type:</span><br/> we can store only numeric value and int data types store from -2147483648 to 2147483647.
</p>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">Integers C++ basic data types Example :</Card.Header>
<Card.Body>

<Card.Text>
<p>
int a=244565
</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a C++ conditional operator</Card.Footer>
</Card>

<p className="mt-4 para">
<span className="bold">B,In long C++ data type:<br/></span>
long data type is used when int can’t handle large value so the long data type in C store value start from -9223372036854775808 
and on 9223372036854775807 and you don’t store the large value inside long data type if you type long data type so you also write capital l like”l” after number end.
</p>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">long C++ basic data types Example :</Card.Header>
<Card.Body>
<Card.Text>
<p>
long a=154252252562572L;<br/><br/>
156  is an int <br/>
156L is a long
</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a C++ conditional operator</Card.Footer>
</Card>

<p className="mt-4 para">
<span className="bold">C,In Short C++ data type:</span><br/>
Short C data type is used when creates a short integer and short data type store hole number from -32768 to 32767
And short is used when you don’t need the large range number like int.

</p>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">Short C++ basic data types Example :</Card.Header>
<Card.Body>

<Card.Text>
<p>
short a=32765 <br/>

</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a C++ conditional operator</Card.Footer>
</Card>

<p className="mt-4 para">
<span className="bold">D,In Byte C++ data type:</span><br/>
Byte C data type is used when The smallest integer type is a byte in integer .byte can store numbers from -128 to 127
</p>
<h2 className="mt-4 ">2,characters C++ data type</h2>
<p className="mt-3 para" >a,Char C++ data type is used to hold a single character, Unicode character <br/>
b,Char data type enclosed by a single quotes 
</p>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">Char C basic data types Example :</Card.Header>
<Card.Body>

<Card.Text>
<p>
char a="z";<br/>
Char b=88;&#47;&#47;code for x learn by unicode<br/>

</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a C++ conditional operator</Card.Footer>
</Card>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">Char C++ basic data types Example :</Card.Header>
<Card.Body>

<Card.Text>
<p>

Ch a,b<br/>
A=“x”;<br/>
B=90 //and-z<br/>
System.out.println(a);<br/>
System.out.println(b);<br/>
</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a C++ conditional operator</Card.Footer>
</Card>

<h2 className="mt-4 ">If you increment character in C++ basic data types:
</h2>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">Char C++ basic data types Example :</Card.Header>
<Card.Body>

<Card.Text>
<p>
Char a;<br/>
A=“x”;<br/>
System.out.println(a);<br/>
A++&#47;&#47; increment a<br/>
System.out.println(a);<br/>
</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a C++ conditional operator</Card.Footer>
</Card>

<h2 className="mt-4 mh2">3,Floating-point C++ data type</h2>
<p className="mt-4 para"> 1,In Floating point data types groups includes float and double and this show number with a fraction.<br/>
2,These floating-point numbers is a real number<br/>
<span className="bold">There are two types of floating-point Data types:<br/>1, float <br/>2,double </span><br/>
*double bits is 64<br/>
*float bits is 32<br/>
</p>

<p className="mt-4 para">
<span className="bold">A,In float C++ data type:</span><br/>
1,float specifies a single-precision value means uses 32bits of storage. <br/>
2,this float is slower than double precision but it takes half as much space as double-precision <br/>
3,the float stores a fractional number from 3.4e−038 to 3.4e+038.<br/>
4,float use for representing dollar and cents<br/>
5,you don’t store float value inside float data type if you type float data type so you also write small f like:”f” after number end. <br/>
</p>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">Float C++ basic data types Example :</Card.Header>
<Card.Body>

<Card.Text>
<p>
float number=40.56f
</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a C++ conditional operator</Card.Footer>
</Card>

<p className="mt-4 para">
<span className="bold">B,In Double C++ data type:<br/></span>
1,double specifies a double-precision value means uses 64 bits of storage.<br/> 
2,double precision is faster than single precision<br/>
3,the double stores' fractional number 1.7e−308 to 1.7e+308<br/>
4,you don’t store the double value inside double data type if you type double data type so you also write small d like:”d” after number end.<br/>
</p>
<Card className='inde' border='primary m-4'>
<Card.Header as="h5">Double C++ basic data types Example :</Card.Header>
<Card.Body>

<Card.Text>
<p>
double a=12.426d;<br/>
Or<br/>
Double a;<br/>
A=12.426d<br/>

</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a C++ conditional operator</Card.Footer>
</Card>

<h2 className="mt-4 mh2">4,Bool C++ data type:</h2>

<p className="mt-3 para">
<span className="bold para">In Bool C++ data type:</span>
In the Boolean C++ data type group include Boolean and this shows only true or false values and using the reserved word true and false.
</p>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">Bool C++ basic data types Example :</Card.Header>
<Card.Body>

<Card.Text>
<p>
Int a=4;<br/>
Int b=8;<br/>
Boolean c=a&#60;b;<br/>
System.out.println(b)<br/>
</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a C++ conditional operator</Card.Footer>
</Card>
<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/csharp-goto">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cdatatype;